import Layout from "../../internal/Layout.vue";
import Showcase from "./Showcase.vue";

const ProductRoutes = {
  component: Layout,
  children: [
    {
      path: "/vitrine/:seller",
      name: "Showcase",
      component: Showcase,
      meta: {},
    },
  ],
};

export default ProductRoutes;
